import {SetFieldFn} from "../../data";
import {aufgabenStyles} from "../../../styles/aufgaben/aufgaben.styles";
import {Box} from "@mui/material";
import SearchField from "../../SearchField";
import {useUpdateSearchParam} from "../../../hooks/useUpdateSearchParams";

export type AufgabenFilter = {
    search?: string;
    filtered?: string;
}

interface FilterTableAufgabenProps {
    search?: string;
    setField: SetFieldFn<AufgabenFilter>;
}

export default function FilterTableAufgaben({ search, setField }: FilterTableAufgabenProps) {
    const updateSearchParam = useUpdateSearchParam();

    const handleSearchChange = (searchString: string) => {
        setField("search", searchString);
        updateSearchParam("search", searchString);
    };

    return (
        <Box sx={aufgabenStyles.filterTableAufgaben.box}>
            <SearchField
                value={search ?? ""}
                onChange={(searchString: string) => handleSearchChange(searchString)}
            />
        </Box>
    );
}